import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Setting";
import Common from "./Common";
import Users from "./Users";
import Dashboard from "./Dashboard";
import Pages from "./Pages";
import Emails from "./Emails";
import Profile from "./Profile";
import Students from "./Students";
import Tutors from "./Tutors";
import CourseCategories from "./CourseCategories";
import RoleManagement from "./RoleManagement";
import LiveCourses from "./LiveCourses";
import LiveCourseSession from "./LiveCourseSession";
import Books from "./Books";
import ProductTypes from "./ProductTypes";
import AdManagement from "./AdManagement";
import Coupons from "./Coupons";
import Blogs from "./Blogs";
import ClientLogo from "./ClientLogo";
import ProfessionalProfile from "./ProfessionalProfile";
import ScientificEvidence from "./ScientificEvidence";
import Products from "./Products";
import QnA from "./QnA";
import Testimonials from "./Testimonials";
import MetaData from "./MetaData";
import MaterialContent from "./MaterialContent";
import HomeTestimonial from "./HomeTestimonial";
import ValueContent from "./ValueContent";
import VideoContentSection from "./VideoContentSection";
import VideoContentItem from "./VideoContentItem";
import ProductTutor from "./ProductTutor";
import BookCategory from "./BookCategory";
import StaticContent from "./StaticContent";
import Post from "./Post";
import ShippingCharges from "./ShippingCharges";
import EHMetaData from "./EH_MetaData";
import EHQnA from "./EH_QnA";
import EHTestimonial from "./EH_Testimonials";
import EHMaterialContent from "./EH_MaterialContent";
import EHValueContent from "./EH_ValueContent";
import EHProductTutor from "./EH_ProductTutor";
import EHCommunity from "./EH_Community";
import EHVideoContentItem from "./EH_VideoContentItem";
import EHVideoContentSection from "./EH_VideoContentSection";
import LanguageManagement from "./LanguageManagement";
import ExchangeRate from "./ExchangeRate";
import OrderManagement from "./OrderManagement";
import OrderItems from "./OrderItems";
import ShippingSupplier from "./ShippingSupplier";
import Rating from "./Rating";
import OutSourceAuthor from "./OutSourceAuthor";
import TaxManagement from "./TaxManagement";
import ContactUs from "./ContactUs";
import WorkWithUS from "./WorkWithUs";
import Comments from "./Comments";
import metaDataInfoReducer from "./MetaDataInfo";
import Quiz from "./Quiz";
import SearchContextReducer from "./SearchContext";
import Review from "./Review";
import Gallery from "./Gallery";
import ShippingZones from "./ShippingZones";

const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    common: Common,
    users: Users,
    dashboard: Dashboard,
    pages: Pages,
    emails: Emails,
    profile: Profile,
    students: Students,
    tutors: Tutors,
    courseCategories: CourseCategories,
    roleManagement: RoleManagement,
    liveCourses: LiveCourses,
    liveCourseSession: LiveCourseSession,
    books: Books,
    productTypes: ProductTypes,
    advertisements: AdManagement,
    coupons: Coupons,
    blogs: Blogs,
    clientLogo: ClientLogo,
    professionalProfile: ProfessionalProfile,
    scientificEvidence: ScientificEvidence,
    products: Products,
    outSourceauthor: OutSourceAuthor,
    qna: QnA,
    testimonial: Testimonials,
    metaData: MetaData,
    metaDataInfo: metaDataInfoReducer,
    materialContent: MaterialContent,
    homeTestimonial: HomeTestimonial,
    valueContent: ValueContent,
    videoContent: VideoContentSection,
    videoItem: VideoContentItem,
    productTutor: ProductTutor,
    bookCategory: BookCategory,
    staticContent: StaticContent,
    post: Post,
    comment: Comments,
    shippingCharge: ShippingCharges,
    eh_metaData: EHMetaData,
    eh_qna: EHQnA,
    eh_testimonial: EHTestimonial,
    eh_materialContent: EHMaterialContent,
    eh_valueContent: EHValueContent,
    eh_productTutor: EHProductTutor,
    eh_comment: EHCommunity,
    eh_videoItem: EHVideoContentItem,
    eh_videoContent: EHVideoContentSection,
    languages: LanguageManagement,
    exchangeRate: ExchangeRate,
    orders: OrderManagement,
    orderItemsData: OrderItems,
    shippingSuppliers: ShippingSupplier,
    rating: Rating,
    taxManagement: TaxManagement,
    contactUs: ContactUs,
    workWithUs: WorkWithUS,
    quiz: Quiz,
    searchContext: SearchContextReducer,
    review: Review,
    gallery: Gallery,
    shippingZones: ShippingZones,
  });

export default reducers;
